import React, { useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { Edit, Trash } from "react-feather";

const VendorList = ({
  vendorData,
  handleEdit,
  handleDelete
}) => {

  return (
    <Table striped bordered hover responsive className="align-middle text-center">
      <thead className="table-dark">
        <tr>
          <th>S.No</th>
          <th>Name</th>
          <th>Address1</th>
          <th>Address2</th>
          <th>State</th>
          <th>PostalCode</th>
          <th>Contact</th>
          {/* <th>CreatedBy</th> */}
          <th>Actions</th>
        </tr>
      </thead>
      <tbody className="custom-employee-table">
        {vendorData.map((data, index) => (
          <tr key={data.id}>
            <td>{index + 1}</td>
            <td>{data.name}</td>
            <td>{data.address1}</td>
            <td>{data.address2}</td>
            <td>{data.address3}</td>
            <td>{data.address4}</td>
            <td>{data.contactNumbers}</td>
            {/* <td>{data.createdBy}</td> */}
            <td className="d-flex">
              <Button
                variant="warning"
                size="sm"
                className="me-2"
                onClick={() => handleEdit(data)}
              >
                <Edit />
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={() => handleDelete(data.id)}
              >
                <Trash />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default VendorList;
